import React, { Component } from 'react';
import { Container, Button } from 'semantic-ui-react';
import { PtSelect } from '../../../../grit-utilities';
import ScrollArea from 'react-scrollbar';

export default class MaintenanceTemplate extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
        console.log(this.props.dataModel)
    }

    render() {
        return (
            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>

                    <h5>{this.props.name}</h5>
                    {/* Add css classes to these later */}
                    <div style={{ width: 60, float: 'left' }
                    }>
                        <PtSelect options={this.props.dataModel} defaultVal={this.props.selectedIndex}
                            onChange={this.onChangeIndex} />
                    </div>
                    <strong style={{ float: 'left', paddingTop: 10 }}>of {this.props.dataModel.length}</strong>

                    <Button style={{ float: 'left', marginTop: 5, marginLeft: 20 }} size='tiny' color='blue' onClick={() => {
                        this.addNewRecord(this.props.dataModel.length);
                    }}
                        disabled={this.props.disabled}
                    >New</Button>

                    <Button style={{ float: 'left', marginTop: 5, marginLeft: 20 }} size='tiny' color='red' onClick={() => {
                        this.deleteRecord(this.props.selectedIndex);
                    }}
                        disabled={this.props.disabled}
                    >Delete</Button>

                    <div style={{ clear: 'both' }}></div>

                    {this.props.dataModel.length > 0 && this.props.renderMaintenance(
                        this.onChangeIndex,
                        this.onChangeDropdown,
                        this.onChangeDropdownEstimated,
                        this.onInputChange,
                        this.onChangeDate)}
                </ScrollArea>
            </Container>);
    }

    deleteRecord(index) {
        var tempArray = this.props.dataModel;
        tempArray.splice(index, 1);
        let i = 0;
        for (const t of tempArray) {
            const lbl = "" + (i + 1);
            t.key = i;
            t.value = i;
            t.label = lbl;
            i++;
        }

        //todo reset all indices
        this.props.triggerNeedSave();
        this.props.deleteRecord(tempArray);//{ selectedIndex: 0, surfacing: tempArray });
    }

    addNewRecord(newIndex) {
        //Add new record to temp array then send to state
        const lbl = "" + (newIndex + 1);
        const tempArray = this.props.dataModel;

        // It is important to note that values are initialized here, unlike the rest of the data structure.
        this.props.templadeData.key = newIndex;
        this.props.templadeData.value = newIndex;
        this.props.templadeData.label = lbl;

        tempArray.push(this.props.templadeData);

        this.props.triggerNeedSave();

        this.props.addRecord(newIndex, tempArray);//{ selectedIndex: newIndex, surfacing: tempArray });
    }


    onChangeIndex = (e) => {
        const { target } = e;
        const { value } = target;

        // Changing this state value.
        // this.setParentState({ selectedIndex: parseInt(value) });
        // eslint-disable-next-line
        this.props.updateSelectedIndex(parseInt(value));
    }

    onChangeDropdown = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();

        //Change value in temp array then send to state
        var tempArray = this.props.dataModel;
        // eslint-disable-next-line
        tempArray[this.props.selectedIndex][name] = parseInt(value);

        this.props.updateDataModel(tempArray);
    }

    onChangeDropdownEstimated = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();

        //Change value in temp array then send to state
        var tempArray = this.props.dataModel;

        // Determine if Dropdown value or Estimated value was changed
        // eslint-disable-next-line
        if ((parseFloat(value) == parseInt(value)) && !isNaN(value)) {
            // eslint-disable-next-line
            tempArray[this.props.selectedIndex][name] = parseInt(value);
        }
        else {
            tempArray[this.props.selectedIndex][name] = value;
        }

        this.props.updateDataModel(tempArray);
    }

    onInputChange = (e) => {
        const { name, value } = e.target;
        this.props.triggerNeedSave();

        //Change value in temp array then send to state
        var tempArray = this.props.dataModel;

        tempArray[this.props.selectedIndex][name] = value;

        this.props.updateDataModel(tempArray);
    }

    onChangeDate = (date, name) => {
        this.props.triggerNeedSave();

        //Change value in temp array then send to state
        var tempArray = this.props.dataModel;
        tempArray[this.props.selectedIndex][name] = date?`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`:null;

        this.props.updateDataModel(tempArray);
    }
}



// WEBPACK FOOTER //
// ./src/layers/tabs/cons-segment/maintenance/maintenance-template.js